import { api } from 'utility';
import { getWithdrawRulePlanUrl } from 'URLs';
export function postRule(data) {
  return api.post(getWithdrawRulePlanUrl(), data).then((res) => res.data);
}
export default {
  postRule,
};
